import { useMemo } from 'react'

import { useDataByMonth } from './useDataByMonth'
import { useChallenge } from '../context'
import { Person } from '../types'

type RankingData = {
  points: number
}
export const useRankingData = (user: Person | null): RankingData => {
  const { challengeList } = useChallenge()
  const {
    currentMonthLogins,
    currentMonthLogs,
    previousMonthLogins,
    previousMonthLogs,
  } = useDataByMonth(user)

  const pointPerLogs = useMemo(() => {
    let counter = 0
    if (currentMonthLogins > previousMonthLogins) counter += 1

    if (currentMonthLogs > previousMonthLogs) counter += 1

    return counter
  }, [
    currentMonthLogins,
    currentMonthLogs,
    previousMonthLogins,
    previousMonthLogs,
  ])

  // sumar puntos por desafios compartido
  const pointPerChallenge = useMemo(() => {
    let counter = 0

    user?.uid &&
      challengeList.map((challenge) => {
        const _points = Number(challenge.points)

        if (
          challenge.participants.length > 0 &&
          challenge.participants.includes(user?.uid)
        ) {
          counter += _points as number
        }
      })

    return counter
  }, [challengeList])

  const points = useMemo(
    () => pointPerLogs + pointPerChallenge,
    [pointPerLogs, pointPerChallenge],
  )

  return { points }
}
